/**
 * Collection Purchase Type / Creator Profile tabs.
 * #creator-profile → show profile, hide grid/sidebar/featured
 * #collection-products (or no profile hash) → show catalog
 */
(function (document) {
  'use strict';

  var PROFILE_HASH = '#creator-profile';
  var POSTS_HASH = '#creator-posts';
  var catalogTab = 'all';

  function getOuter() {
    return document.querySelector('[data-productgrid-outer]');
  }

  function getTabs() {
    return document.querySelectorAll('[data-og-collection-tab]');
  }

  function setActiveTab(id) {
    getTabs().forEach(function (tab) {
      var on = tab.getAttribute('data-og-collection-tab') === id;
      tab.classList.toggle('is-active', on);
      if (on) {
        tab.setAttribute('aria-current', 'page');
      } else {
        tab.removeAttribute('aria-current');
      }
    });
  }

  function applyHash() {
    var outer = getOuter();
    if (!outer || !document.getElementById('creator-profile')) return;
    catalogTab = outer.dataset.ogBoostCatalogTab || catalogTab;

    var isProfile = window.location.hash === PROFILE_HASH;
    var posts = document.getElementById('creator-posts');
    var isPosts = window.location.hash === POSTS_HASH && !!posts;
    outer.classList.toggle('is-creator-profile', isProfile);
    outer.classList.toggle('is-creator-posts', isPosts);
    if (posts) posts.setAttribute('aria-hidden', isPosts ? 'false' : 'true');

    var profile = document.getElementById('creator-profile');
    if (profile) {
      profile.setAttribute('aria-hidden', isProfile ? 'false' : 'true');
    }

    setActiveTab(isProfile ? 'profile' : isPosts ? 'posts' : catalogTab);
  }

  function detectFilterTab() {
    var active = document.querySelector(
      '[data-og-collection-tab].is-active:not([data-og-collection-tab="profile"]):not([data-og-collection-tab="posts"])'
    );
    if (active) return active.getAttribute('data-og-collection-tab');
    return 'all';
  }

  function onReady() {
    catalogTab = detectFilterTab();
    applyHash();

    if (window.location.hash === PROFILE_HASH || window.location.hash === POSTS_HASH) {
      var profile = document.getElementById(window.location.hash === POSTS_HASH ? 'creator-posts' : 'creator-profile');
      if (profile) {
        requestAnimationFrame(function () {
          profile.scrollIntoView({ block: 'start' });
        });
      }
    }

    window.addEventListener('hashchange', applyHash);

    // Same-page profile click: avoid full reload when already on unfiltered URL
    document.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-og-collection-tab="profile"], [data-og-collection-tab="posts"]');
      if (!tab) return;
      var href = tab.getAttribute('href') || '';
      var targetHash = tab.getAttribute('data-og-collection-tab') === 'posts' ? POSTS_HASH : PROFILE_HASH;
      if (href.indexOf(targetHash) === -1) return;

      var url;
      try {
        url = new URL(tab.href, window.location.origin);
      } catch (e) {
        return;
      }

      var current = new URL(window.location.href);
      current.hash = '';
      url.hash = '';
      if (current.pathname === url.pathname && current.search === url.search) {
        event.preventDefault();
        if (window.location.hash !== targetHash) {
          window.location.hash = targetHash;
        } else {
          applyHash();
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})(document);
